import { styled, css } from 'styled-components';
import { Media } from '../../../theme/Media';
import { Loader } from '../../Elements/Loader';
import { BUTTON_SIZE_SMALL_PX, BUTTON_SIZE_DEFAULT_PX } from './constants';
export const ButtonWrapper = styled.button `
  position: relative;
  cursor: pointer;
  border-radius: 8px;
  padding: ${({ variant, iconOnly }) => {
    if (iconOnly) {
        return '8px';
    }
    return variant === 'ghost' ? '4px 0px' : '8px 16px';
}};
  border: none;
  width: ${({ iconOnly, fullWidth }) => (iconOnly ? BUTTON_SIZE_DEFAULT_PX : fullWidth ? '100%' : 'auto')};
  height: ${({ variant, iconOnly }) => (variant === 'ghost' && !iconOnly ? BUTTON_SIZE_SMALL_PX : BUTTON_SIZE_DEFAULT_PX)};
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ theme }) => theme.typography.weightMedium}
  ${({ theme }) => theme.typography.textMedium}

  &:focus-visible,
  &:focus {
    outline: none;
    ${({ theme }) => theme.shadows.focus}
  }

  &:disabled {
    cursor: not-allowed;
    color: ${({ theme }) => theme.colors.grey100_2};
  }

  ${({ theme, variant }) => variant === 'primary' &&
    css `
      background-color: ${theme.colors.main};
      color: ${theme.colors.grey00_2};

      &:not(:disabled):hover {
        background-color: ${theme.colors.mainDark};
      }

      &:disabled {
        background-color: ${theme.colors.grey10_2};
      }
    `}

  ${({ theme, variant }) => variant === 'secondary' &&
    css `
      background-color: ${theme.colors.grey00_1};
      color: ${theme.colors.black_1};
      border: 1px solid ${theme.colors.black_1};

      &:not(:disabled):hover {
        color: ${theme.colors.blackDark_1};
        border: 1px solid ${theme.colors.blackDark_1};
      }

      &:disabled {
        background-color: ${theme.colors.grey10_2};
        border: 1px solid ${theme.colors.grey10_2};
      }
    `}

  ${({ theme, variant }) => variant === 'critical' &&
    css `
      background-color: ${theme.colors.critical100};
      color: ${theme.colors.grey00_2};

      &:not(:disabled):hover {
        background-color: ${theme.colors.critical120_1};
      }

      &:disabled {
        background-color: ${theme.colors.grey10_2};
      }
    `}

  ${({ theme, variant }) => variant === 'ghost' &&
    css `
      background-color: transparent;
      color: ${theme.colors.black_1};

      &:not(:disabled):hover {
        color: ${theme.colors.blackDark_1};
      }
    `}

  @media ${Media.xsMax} {
    ${({ variant, iconOnly }) => variant !== 'ghost' &&
    css `
        width: ${iconOnly ? BUTTON_SIZE_DEFAULT_PX : '100%'};
      `}
  }
`;
export const ButtonContent = styled.div `
  align-items: center;
  display: inline-flex;
  justify-content: center;
  gap: ${({ $reducedGap }) => ($reducedGap ? '2px' : '8px')};
  white-space: nowrap;

  ${({ $isLoading }) => $isLoading &&
    css `
      opacity: 0;
    `}
`;
export const StyledLoader = styled(Loader) `
  position: absolute;
  inset: 0;
  margin: auto;
`;
